import React from "react";

export default function CondosForSale() {
  return <div>CondosForSale</div>;
}
